import {Mapper} from '@s-ui/domain'

export class FromLeadHitUserVOToLeadHitUserRequestMapper extends Mapper {
  constructor({config, leadHitUserRequestFactory}) {
    super()
    this._config = config
    this._leadHitUserRequestFactory = leadHitUserRequestFactory
    this._leadTypes = this._config.get('user').LEAD_HIT_TYPES
  }

  _getPath = ({adId, contractId, leadType}) => {
    const basePath = '/hits'
    const dealerPath = '/dealers'
    const adPath = '/vehicles'

    switch (leadType) {
      case this._leadTypes.VIEW_AD_PHONE:
        return `${basePath}${adPath}/${adId}/phone-view`
      case this._leadTypes.VIEW_DEALER_PHONE:
        return `${basePath}${dealerPath}/${contractId}/phone-view`
      case this._leadTypes.CALL_AD:
        return `${basePath}${adPath}/${adId}/call`
      case this._leadTypes.CALL_DEALER:
        return `${basePath}${dealerPath}/${contractId}/call`
      default:
        return null
    }
  }

  map = leadHitVO => {
    const {adId, contractId, leadType} = leadHitVO.toJSON()

    const apiUrl = this._config.get('API_URL')
    const path = this._getPath({adId, contractId, leadType})
    const endpointUrl = path ? `${apiUrl}${path}` : null

    return this._leadHitUserRequestFactory({endpointUrl})
  }
}
